import { render, staticRenderFns } from "./unidad1.vue?vue&type=template&id=0b43df42&scoped=true&"
import script from "./unidad1.vue?vue&type=script&lang=js&"
export * from "./unidad1.vue?vue&type=script&lang=js&"
import style0 from "./unidad1.vue?vue&type=style&index=0&id=0b43df42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43df42",
  null
  
)

export default component.exports